import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ChevronRight, Briefcase } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const ROLE_LABELS = { profesor: "Profesor", psicologo: "Psicólogo", administrativo: "Administrativo" };

export default function TrabajadoresLista() {
    const navigate = useNavigate();
    const [staff, setStaff] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");

    useEffect(() => {
        setLoading(true);
        api.get("/users", { params: { role: "profesor,psicologo,administrativo" } })
            .then((r) => setStaff(r.data || []))
            .catch(() => toast.error("Error cargando trabajadores"))
            .finally(() => setLoading(false));
    }, []);

    const filtered = staff.filter((s) => (s.name || "").toLowerCase().includes(search.toLowerCase()));

    return (
        <div className="p-6 md:p-10 fade-in min-h-screen max-w-2xl mx-auto">
            <h1 className="text-2xl font-semibold mb-1 inline-flex items-center gap-2"><Briefcase size={22} className="text-edu-navy" /> Trabajadores</h1>
            <p className="text-edu-muted mb-6">Hoja de vida del personal del colegio. Busca para ver o editar.</p>

            <div className="relative mb-4">
                <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-edu-muted" />
                <input
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Buscar por nombre…"
                    className="edu-input w-full pl-9"
                    autoFocus
                />
            </div>

            {loading ? (
                <p className="text-sm text-edu-muted">Cargando…</p>
            ) : filtered.length === 0 ? (
                <div className="edu-card p-8 text-center text-edu-muted">No se encontraron trabajadores.</div>
            ) : (
                <div className="space-y-2">
                    {filtered.map((s) => (
                        <button
                            key={s.id}
                            onClick={() => navigate(`/admin/trabajadores/${s.id}`)}
                            className="edu-card w-full text-left p-4 hover:bg-edu-soft transition-colors flex items-center justify-between gap-3"
                        >
                            <div>
                                <p className="font-medium text-sm">{s.name}</p>
                                <p className="text-xs text-edu-muted">{s.cargo || ROLE_LABELS[s.role] || s.role}</p>
                            </div>
                            <ChevronRight size={16} className="text-edu-muted" />
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
